import React from 'react';
import { Alert } from 'react-bootstrap';
import ClaimStateAlerts from '../claim/ClaimStateAlerts';
import HelpControls from '../financialSection/HelpControls';
import { createTimezonedDate } from './date';
export function CostAlertsAndHelpControls(_ref) {
  let {
    claim,
    placeholder = 'Name      Net Amount',
    extraDescription,
    onSubmit
  } = _ref;
  const formattedDescription = extraDescription ? ` ${extraDescription.trim()}` : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement(Alert, {
    variant: "info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "info"), " Please ensure that all costs were incurred between ", createTimezonedDate(claim.from_date).toCustomLocaleDateString(), " and ", createTimezonedDate(claim.to_date).toCustomLocaleDateString(), "."), /*#__PURE__*/React.createElement(HelpControls, {
    claim: claim,
    importProps: {
      placeholder: 'Name      Net Amount',
      formattedDescription,
      onSubmit
    }
  }));
}